import type { Filters } from '@cognite/fdm-client';

export const notArchivedFilter: Filters = {
  not: {
    equals: {
      property: 'isArchived',
      eq: true,
    },
  },
};
